var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent is-vertical" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _vm.innerValue.sendQuoteType !== _vm.ormSendQuoteTypes.RequestInspection
          ? _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Vehicle located at"),
                  ]),
                  _c("div", { staticClass: "select" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.innerValue.vehicleLocation,
                            expression: "innerValue.vehicleLocation",
                          },
                        ],
                        attrs: { autofocus: "" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.innerValue,
                              "vehicleLocation",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "Repairer" } }, [
                          _vm._v("Repairer"),
                        ]),
                        _c("option", { attrs: { value: "Customer" } }, [
                          _vm._v("Customer"),
                        ]),
                        _c("option", { attrs: { value: "RMC" } }, [
                          _vm._v("RMC"),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("div", { staticClass: "control is-pulled-right" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mapSource,
                            expression: "mapSource",
                          },
                        ],
                        staticClass: "is-checkradio is-small is-rtl",
                        attrs: {
                          id: "chk-orm-google",
                          name: "chk-orm-google",
                          value: "GoogleSuburbAutocomplete",
                          type: "radio",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.mapSource,
                            "GoogleSuburbAutocomplete"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            _vm.mapSource = "GoogleSuburbAutocomplete"
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "chk-orm-google" } }, [
                        _vm._v("Google"),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mapSource,
                            expression: "mapSource",
                          },
                        ],
                        staticClass: "is-checkradio is-small is-rtl",
                        attrs: {
                          id: "chk-orm-mapbox",
                          name: "chk-orm-mapbox",
                          value: "MapboxSuburbAutocomplete",
                          type: "radio",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.mapSource,
                            "MapboxSuburbAutocomplete"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            _vm.mapSource = "MapboxSuburbAutocomplete"
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "chk-orm-mapbox" } }, [
                        _vm._v("Mapbox"),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [_vm._v("Suburb")]),
                    _c(
                      "div",
                      { staticClass: "control is-expanded" },
                      [
                        _c(_vm.mapSource, {
                          tag: "component",
                          model: {
                            value: _vm.innerValue.vehicleSuburb,
                            callback: function ($$v) {
                              _vm.$set(_vm.innerValue, "vehicleSuburb", $$v)
                            },
                            expression: "innerValue.vehicleSuburb",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm.innerValue.sendQuoteType === _vm.ormSendQuoteTypes.TotalLoss
          ? _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Total Loss Reason"),
              ]),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.innerValue.totalLossReason,
                    expression: "innerValue.totalLossReason",
                  },
                ],
                staticClass: "textarea",
                attrs: { rows: "5" },
                domProps: { value: _vm.innerValue.totalLossReason },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.innerValue,
                      "totalLossReason",
                      $event.target.value
                    )
                  },
                },
              }),
            ])
          : _vm._e(),
        _vm.innerValue.sendQuoteType === _vm.ormSendQuoteTypes.RequestInspection
          ? _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Request Inspection Reason"),
              ]),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.innerValue.inspectionReason,
                    expression: "innerValue.inspectionReason",
                  },
                ],
                staticClass: "textarea",
                attrs: { rows: "5" },
                domProps: { value: _vm.innerValue.inspectionReason },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.innerValue,
                      "inspectionReason",
                      $event.target.value
                    )
                  },
                },
              }),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }